import angular from 'angular'
import authorizationService from './authorization.service'

export default angular
  .module('ellipsis.authorization', [])
  .service('authorizationService', authorizationService)
